import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = {
  root: {padding: 16, position: "relative"}
};

const PaperContainer = ({ children, classes }) => (
  <Paper className={classes.root}>{children}</Paper>
);

export default withStyles(styles)(PaperContainer);